document.addEventListener('DOMContentLoaded', function() {
console.log('Sticky cart script loaded');

// SIMPLE BUT EFFECTIVE CHECK: Only run on product pages
const hasProductForm = document.querySelector('form[action*="/cart/add"]');
const isProductURL = window.location.pathname.includes('/products/') && 
                     !window.location.pathname.includes('/collections/');

console.log('Product form found:', !!hasProductForm);
console.log('Product URL:', isProductURL);
console.log('Current URL:', window.location.pathname);

if (!hasProductForm || !isProductURL) {
  console.log('Not a product page - sticky cart disabled');
  return;
}

let isLoading = false;
let itemAddedToCart = false;
let currentProductId = null;
let isCurrentVariantAvailable = true;
let lastCheckedVariantId = null;

function createStickyButton() {
  console.log('Creating sticky button');
  
  const form = document.querySelector('form[action*="/cart/add"]');
  const variantInput = form.querySelector('input[name="id"], select[name="id"]');
  
  if (!variantInput || !variantInput.value) {
    console.log('No variant ID found');
    return;
  }

  // Store current product ID for cart monitoring
  if (window.product && window.product.id) {
    currentProductId = window.product.id;
    console.log('Current product ID:', currentProductId);
  }

  let price = '35.98';
  let comparePrice = '102.00';
  let currency = 'AED';
  let isOnSale = true;

  // Initial variant availability check
  checkCurrentVariantAvailability();

  if (window.product && window.product.selected_variant) {
    const variant = window.product.selected_variant;
    price = (variant.price / 100).toFixed(2);
    if (variant.compare_at_price) {
      comparePrice = (variant.compare_at_price / 100).toFixed(2);
      isOnSale = variant.compare_at_price > variant.price;
    } else {
      isOnSale = false;
    }
  }

  const discountPercent = isOnSale ? Math.round(((parseFloat(comparePrice) - parseFloat(price)) / parseFloat(comparePrice)) * 100) : 0;
  
  // Dynamic button text based on variant availability
  let discountText;
  if (!isCurrentVariantAvailable) {
    discountText = 'Sold Out';
  } else if (isOnSale) {
    discountText = `-${discountPercent}% now! Add to cart!`;
  } else {
    discountText = 'Add to cart!';
  }

  const priceHTML = isOnSale ? 
    `<span class="original-price">${comparePrice}</span><span class="currency">${currency}</span><span class="new-price">${price}</span>` :
    `<span class="currency">${currency}</span><span class="new-price">${price}</span>`;

  const stickyHTML = `
    <div class="sticky-cart-container" id="stickyCartContainer">
      <button class="sticky-cart-button ${!isCurrentVariantAvailable ? 'sold-out' : ''}" id="stickyCartButton" type="button" ${!isCurrentVariantAvailable ? 'disabled' : ''}>
        <div class="spinner"></div>
        <div class="button-content" id="buttonContent">
          <div class="price-section" ${!isCurrentVariantAvailable ? 'style="opacity: 0.6;"' : ''}>${priceHTML}</div>
          <div class="discount-text">${discountText}</div>
        </div>
        <div class="go-to-cart-content" id="goToCartContent" style="display: none;">
          <div class="go-to-cart-text">Go to Cart</div>
        </div>
      </button>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', stickyHTML);
  
  setTimeout(() => {
    const container = document.getElementById('stickyCartContainer');
    if (container) {
      container.classList.add('show');
      console.log('Sticky button shown');
    }
  }, 200);

  const button = document.getElementById('stickyCartButton');
  if (button) {
    button.addEventListener('click', handleButtonClick);
    console.log('Button event listener added');
  }

  // Start monitoring cart changes
  startCartMonitoring();
  
  // Start cart drawer z-index monitoring
  startCartDrawerZIndexMonitoring();
  
  // Monitor variant changes for availability (SIMPLIFIED)
  startVariantAvailabilityMonitoring();
}

function getCurrentVariantId() {
  // Try to get current variant ID from multiple sources
  const variantInput = document.querySelector('input[name="id"], select[name="id"]');
  if (variantInput && variantInput.value) {
    return parseInt(variantInput.value);
  }
  
  if (window.product && window.product.selected_variant) {
    return window.product.selected_variant.id;
  }
  
  return null;
}

function checkCurrentVariantAvailability() {
  const currentVariantId = getCurrentVariantId();
  
  if (!currentVariantId) {
    console.log('No variant ID found, defaulting to available');
    isCurrentVariantAvailable = true;
    return;
  }
  
  // Avoid redundant checks
  if (currentVariantId === lastCheckedVariantId) {
    return;
  }
  
  lastCheckedVariantId = currentVariantId;
  console.log('Checking availability for variant ID:', currentVariantId);
  
  // Method 1: Check window.product.selected_variant (most reliable)
  if (window.product && window.product.selected_variant && window.product.selected_variant.id === currentVariantId) {
    isCurrentVariantAvailable = window.product.selected_variant.available;
    console.log('Variant availability from selected_variant:', isCurrentVariantAvailable);
    return;
  }
  
  // Method 2: Check variants array
  if (window.product && window.product.variants) {
    const currentVariant = window.product.variants.find(v => v.id === currentVariantId);
    if (currentVariant) {
      isCurrentVariantAvailable = currentVariant.available;
      console.log('Variant availability from variants array:', isCurrentVariantAvailable);
      return;
    }
  }
  
  // Method 3: Check main add to cart button (fallback)
  const mainAddToCartButton = document.querySelector('button[name="add"], input[name="add"], .btn-product-add, [data-add-to-cart]');
  if (mainAddToCartButton) {
    isCurrentVariantAvailable = !mainAddToCartButton.disabled && !mainAddToCartButton.classList.contains('disabled');
    console.log('Variant availability from main button:', isCurrentVariantAvailable);
    return;
  }
  
  // Default to available
  isCurrentVariantAvailable = true;
  console.log('Could not determine variant availability, defaulting to available');
}

function startVariantAvailabilityMonitoring() {
  console.log('Starting simplified variant availability monitoring...');
  
  // Single debounced function to handle all variant changes
  let variantChangeTimeout;
  
  function handleVariantChange() {
    clearTimeout(variantChangeTimeout);
    variantChangeTimeout = setTimeout(() => {
      console.log('Variant change detected, updating...');
      checkCurrentVariantAvailability();
      updateButtonAvailability();
      
      // Reset cart state when variant changes
      itemAddedToCart = false;
      showAddToCartState();
    }, 300); // Debounce to prevent rapid changes
  }
  
  // Watch for variant input changes
  const variantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
  variantInputs.forEach(input => {
    input.addEventListener('change', handleVariantChange);
  });
  
  // Watch for variant selector changes (radio buttons, dropdowns, etc.)
  const variantSelectors = document.querySelectorAll('variant-selects input, variant-radios input, .variant-input, [data-variant-input]');
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', handleVariantChange);
  });
  
  // Watch for any form changes that might affect variants
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('change', handleVariantChange);
  }
  
  // Periodic check for product object changes (less frequent)
  let lastKnownVariantId = getCurrentVariantId();
  setInterval(() => {
    const currentVariantId = getCurrentVariantId();
    if (currentVariantId && currentVariantId !== lastKnownVariantId) {
      console.log('Product variant changed via product object');
      lastKnownVariantId = currentVariantId;
      handleVariantChange();
    }
  }, 1000); // Check every second instead of 500ms
}

function updateButtonAvailability() {
  const button = document.getElementById('stickyCartButton');
  if (!button) return;
  
  const discountTextElement = button.querySelector('.discount-text');
  const priceSection = button.querySelector('.price-section');
  
  console.log('Updating button availability:', isCurrentVariantAvailable);
  
  if (!isCurrentVariantAvailable) {
    // Current variant is sold out
    button.classList.add('sold-out');
    button.disabled = true;
    discountTextElement.textContent = 'Sold Out';
    priceSection.style.opacity = '0.6';
    console.log('Button updated to Sold Out state');
  } else {
    // Current variant is available
    button.classList.remove('sold-out');
    button.disabled = false;
    priceSection.style.opacity = '1';
    
    // Update text based on sale status
    if (window.product && window.product.selected_variant) {
      const variant = window.product.selected_variant;
      const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      
      if (isOnSale) {
        const discountPercent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        discountTextElement.textContent = `-${discountPercent}% now! Add to cart!`;
      } else {
        discountTextElement.textContent = 'Add to cart!';
      }
    } else {
      discountTextElement.textContent = 'Add to cart!';
    }
    console.log('Button updated to Available state');
  }
}

function handleButtonClick(e) {
  e.preventDefault();
  console.log('Button clicked, itemAddedToCart:', itemAddedToCart);
  
  // Don't do anything if current variant is sold out
  if (!isCurrentVariantAvailable) {
    console.log('Current variant is sold out - click ignored');
    return;
  }
  
  if (itemAddedToCart) {
    // Go to cart page when "Go to Cart" is clicked
    console.log('Going to cart page...');
    window.location.href = '/cart';
  } else {
    addToCartUsingDawn();
  }
}

// Monitor cart drawer and ensure it appears above the button
function startCartDrawerZIndexMonitoring() {
  console.log('Starting cart drawer z-index monitoring...');
  
  // Set button to lower z-index initially
  const stickyContainer = document.getElementById('stickyCartContainer');
  if (stickyContainer) {
    stickyContainer.style.zIndex = '1000'; // Lower z-index for button
  }
  
  // Check every 300ms for cart drawer and boost its z-index
  setInterval(() => {
    const cartDrawers = document.querySelectorAll('cart-drawer, .cart-drawer, [data-cart-drawer], .drawer--cart');
    
    cartDrawers.forEach(drawer => {
      if (drawer) {
        // Ensure cart drawer has higher z-index than button
        const currentZIndex = window.getComputedStyle(drawer).zIndex;
        if (currentZIndex === 'auto' || parseInt(currentZIndex) <= 1000) {
          drawer.style.zIndex = '10000'; // Much higher than button
          console.log('Cart drawer z-index boosted to 10000');
        }
      }
    });
    
    // Also check for cart drawer backdrop/overlay
    const cartOverlays = document.querySelectorAll('.cart-drawer-overlay, .drawer-overlay, [data-cart-drawer-overlay]');
    cartOverlays.forEach(overlay => {
      if (overlay) {
        overlay.style.zIndex = '9999'; // Just below drawer but above button
      }
    });
    
  }, 300);
}

// Monitor cart changes to detect product removal
function startCartMonitoring() {
  console.log('Starting cart monitoring...');
  
  // Listen for Dawn's cart events
  document.addEventListener('cart:updated', handleCartUpdate);
  document.addEventListener('cart:refresh', handleCartUpdate);
  
  // Also listen for manual cart checks
  setInterval(checkCartStatus, 2000); // Check every 2 seconds
}

function handleCartUpdate(event) {
  console.log('Cart update detected:', event.type);
  checkCartStatus();
}

function checkCartStatus() {
  if (!currentProductId) return;
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Checking cart status...');
      
      // Check if current product is in cart
      const productInCart = cart.items.some(item => item.product_id === currentProductId);
      
      console.log('Product in cart:', productInCart);
      console.log('Current itemAddedToCart state:', itemAddedToCart);
      
      if (!productInCart && itemAddedToCart) {
        // Product was removed from cart, revert button
        console.log('Product removed from cart - reverting button');
        revertToAddToCart();
      } else if (productInCart && !itemAddedToCart) {
        // Product is in cart but button shows Add to Cart (page refresh scenario)
        console.log('Product found in cart - switching to Go to Cart');
        itemAddedToCart = true;
        showGoToCartState();
      }
    })
    .catch(error => {
      console.log('Cart status check failed:', error);
    });
}

function revertToAddToCart() {
  console.log('Reverting button to Add to Cart state');
  itemAddedToCart = false;
  showAddToCartState();
  
  // Add a subtle animation to indicate the change
  const button = document.getElementById('stickyCartButton');
  if (button) {
    button.classList.add('reverted');
    setTimeout(() => {
      button.classList.remove('reverted');
    }, 500);
  }
}

// Use Dawn's built-in add to cart functionality
function addToCartUsingDawn() {
  if (isLoading || !isCurrentVariantAvailable) return;
  
  console.log('Adding to cart using Dawn functions...');
  const button = document.getElementById('stickyCartButton');
  const productForm = document.querySelector('product-form form[action*="/cart/add"]');
  
  if (!productForm) {
    console.log('No product-form found, trying regular form');
    addToCartFallback();
    return;
  }

  isLoading = true;
  button.classList.add('loading');

  try {
    // Find Dawn's product form element
    const productFormElement = document.querySelector('product-form');
    
    if (productFormElement && typeof productFormElement.onSubmitHandler === 'function') {
      console.log('Using Dawn product-form onSubmitHandler');
      
      // Create a fake submit event
      const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      
      // Set a timeout to ensure loading state doesn't get stuck
      const loadingTimeout = setTimeout(() => {
        console.log('Loading timeout reached, assuming success');
        handleAddToCartSuccess();
      }, 1000); // Short timeout
      
      // Override the default behavior to handle our custom flow
      const originalHandler = productFormElement.onSubmitHandler;
      
      productFormElement.onSubmitHandler = function(event) {
        event.preventDefault();
        
        // Call Dawn's original handler
        const handlerResult = originalHandler.call(this, event);
        
        // Check if it returns a promise
        if (handlerResult && typeof handlerResult.then === 'function') {
          handlerResult
            .then(() => {
              clearTimeout(loadingTimeout);
              console.log('Dawn add to cart completed successfully');
              handleAddToCartSuccess();
            })
            .catch((error) => {
              clearTimeout(loadingTimeout);
              console.error('Dawn add to cart failed:', error);
              handleAddToCartError(error);
            });
        } else {
          // If no promise returned, assume success after short delay
          setTimeout(() => {
            clearTimeout(loadingTimeout);
            console.log('Dawn handler completed (no promise)');
            handleAddToCartSuccess();
          }, 300);
        }
      };
      
      // Trigger the form submission
      productForm.dispatchEvent(submitEvent);
      
    } else {
      console.log('No Dawn product-form handler found, using fallback');
      addToCartFallback();
    }
    
  } catch (error) {
    console.error('Error with Dawn integration:', error);
    addToCartFallback();
  }
}

// Fallback method if Dawn integration doesn't work
function addToCartFallback() {
  console.log('Using fallback add to cart method');
  const button = document.getElementById('stickyCartButton');
  const form = document.querySelector('form[action*="/cart/add"]');
  
  if (!form) {
    alert('Product form not found');
    return;
  }

  isLoading = true;
  button.classList.add('loading');

  const formData = new FormData(form);
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    if (response.ok) {
      return response.json();
    }
    throw new Error('Failed to add to cart');
  })
  .then(data => {
    console.log('Fallback add to cart successful:', data);
    handleAddToCartSuccess();
  })
  .catch(error => {
    console.error('Fallback add to cart failed:', error);
    handleAddToCartError(error);
  });
}

function handleAddToCartSuccess() {
  console.log('Add to cart success handler');
  const button = document.getElementById('stickyCartButton');
  
  button.classList.remove('loading');
  button.classList.add('success');
  itemAddedToCart = true;

  // Trigger Dawn's cart update events
  triggerDawnCartUpdate();

  setTimeout(() => {
    button.classList.remove('success');
    showGoToCartState();
    isLoading = false;
    
    // Open cart drawer after Dawn has updated
    setTimeout(() => {
      openCartDrawer();
    }, 200);
  }, 600);
}

function handleAddToCartError(error) {
  console.error('Add to cart error handler:', error);
  const button = document.getElementById('stickyCartButton');
  
  button.classList.remove('loading');
  isLoading = false;
  alert('Error adding item to cart: ' + (error.message || 'Unknown error'));
}

// Trigger Dawn's built-in cart update mechanisms
function triggerDawnCartUpdate() {
  console.log('Triggering Dawn cart updates...');
  
  // Method 1: Dispatch Dawn's cart events
  const cartEvents = [
    'cart:updated',
    'cart:refresh',
    'cart:build',
    'variant:change'
  ];
  
  cartEvents.forEach(eventName => {
    document.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail: { source: 'sticky-cart' }
    }));
  });

  // Method 2: Try to trigger Dawn's cart notification
  const cartNotification = document.querySelector('cart-notification');
  if (cartNotification && typeof cartNotification.renderContents === 'function') {
    console.log('Triggering cart notification update');
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cartNotification.renderContents(cart);
      });
  }

  // Method 3: Update cart drawer if it exists
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    console.log('Found cart drawer, triggering update');
    
    // Try Dawn's built-in refresh method
    if (typeof cartDrawer.getSectionsToRender === 'function') {
      cartDrawer.getSectionsToRender().forEach((section) => {
        fetch(`${window.routes.cart_url}?section_id=${section.id}`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newSection = doc.querySelector(`#${section.id}`);
            if (newSection) {
              document.querySelector(`#${section.id}`).innerHTML = newSection.innerHTML;
            }
          });
      });
    }
  }
}

function showGoToCartState() {
  const buttonContent = document.getElementById('buttonContent');
  const goToCartContent = document.getElementById('goToCartContent');
  
  if (buttonContent && goToCartContent) {
    buttonContent.style.display = 'none';
    goToCartContent.style.display = 'flex';
    console.log('Switched to Go to Cart state');
  }
}

function showAddToCartState() {
  const buttonContent = document.getElementById('buttonContent');
  const goToCartContent = document.getElementById('goToCartContent');
  
  if (buttonContent && goToCartContent) {
    buttonContent.style.display = 'flex';
    goToCartContent.style.display = 'none';
    console.log('Switched to Add to Cart state');
  }
}

function openCartDrawer() {
  console.log('Opening cart drawer using Dawn methods...');
  
  // Method 1: Try Dawn's cart drawer directly
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.open === 'function') {
    console.log('Using Dawn cart drawer open method');
    cartDrawer.open();
    return;
  }

  // Method 2: Try clicking Dawn's cart icon
  const cartIcon = document.querySelector('cart-icon-bubble, .cart-count-bubble');
  if (cartIcon) {
    console.log('Clicking Dawn cart icon');
    cartIcon.click();
    return;
  }

  // Method 3: Try other cart triggers
  const cartSelectors = [
    '.header__icon--cart',
    '[data-cart-drawer-toggle]',
    '.cart-link',
    'summary[aria-label*="cart" i]',
    'details[data-disclosure] summary'
  ];

  for (const selector of cartSelectors) {
    const element = document.querySelector(selector);
    if (element) {
      console.log('Found cart trigger:', selector);
      element.click();
      return;
    }
  }

  console.log('No cart trigger found, going to cart page');
  window.location.href = '/cart';
}

createStickyButton();
});